/**
 * Module Studio (UPT-2079 lot L2, §5.4) — chemin d'un document de spec dans le
 * dépôt du module : motif `DESIGN_LIMITS.specPathPattern`, longueur bornée,
 * aucun segment « . » ni « .. » (rest §4.4.2). Fonctions pures.
 */
import { DESIGN_LIMITS, type DesignSpecKind } from '../data/contracts';

const PATH_PATTERN = new RegExp(DESIGN_LIMITS.specPathPattern);

/** Vrai quand le chemin est accepté par le serveur. */
export const isSpecPath = (path: string): boolean => {
  if (path.length === 0 || path.length > DESIGN_LIMITS.specPathMaxChars) {
    return false;
  }
  if (!PATH_PATTERN.test(path)) {
    return false;
  }
  return path.split('/').every((segment) => segment !== '.' && segment !== '..');
};

/**
 * Chemin proposé dès que le type et le ticket sont connus : `web/SPEC-UPT-n.md`,
 * `rest/SPEC-UPT-n.md`, `_shared/SPEC-UPT-n.md`, `reports/UPT-n.md`.
 */
export const proposeSpecPath = (kind: DesignSpecKind, ticketRef: string): string => {
  switch (kind) {
    case 'shared':
      return `_shared/SPEC-${ticketRef}.md`;
    case 'report':
      return `reports/${ticketRef}.md`;
    default:
      return `${kind}/SPEC-${ticketRef}.md`;
  }
};
